import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { CollapsibleDataGrid, Icon, IconButton, Spacer, Stack, useTheme } from '@emburse/embark-core';
import { CardIcon, CheckIcon, SyncIcon, UndoIcon } from '@emburse/embark-icons';
import { Checkbox } from '../../../../components';
import { $t, useTranslation } from '../../../../hooks/useTranslation';
function ERPGatewayExportErrorsGrid({ data, isActiveStatus, onCheck, onButtonClick }) {
    useTranslation();
    const theme = useTheme();
    const columns = () => [
        {
            field: 'Date',
            headerName: $t('Date'),
            width: 300,
            type: 'string'
        },
        {
            field: 'Amount',
            headerName: $t('Amount'),
            width: 300,
            type: 'string'
        },
        {
            field: 'IsCard',
            renderHeader: () => _jsx("span", {}),
            width: 50,
            renderCell: (cell) => cell.value && (_jsx(Icon, { iconUrl: CardIcon, style: { color: theme.palette.text.secondary } }))
        },
        {
            field: 'ErrorMessage',
            headerName: $t('Error Message'),
            width: 575,
            type: 'string'
        }
    ];
    const buttonClickHandler = (e) => {
        onButtonClick(data.id);
        e.stopPropagation();
    };
    const summary = () => [
        {
            reactNode: (_jsx(Checkbox, { label: `${data.Name}, ${data.Company}, ${data.Amount}`, onChange: () => onCheck(!data.selected, data.id), style: { marginLeft: '15px' } }))
        },
        {
            reactNode: (_jsxs(Stack, { direction: "row", spacing: 0, justifyContent: "space-between", children: [_jsx(IconButton, { color: "primary", disabled: !isActiveStatus, onClick: buttonClickHandler, children: _jsx(Icon, { iconUrl: CheckIcon }) }), _jsx(IconButton, { color: "primary", disabled: !isActiveStatus, onClick: buttonClickHandler, children: _jsx(Icon, { iconUrl: UndoIcon }) }), _jsx(IconButton, { color: "primary", disabled: !isActiveStatus, onClick: buttonClickHandler, children: _jsx(Icon, { iconUrl: SyncIcon }) })] }))
        }
    ];
    return (_jsxs(_Fragment, { children: [_jsx(CollapsibleDataGrid, { columns: columns(), rows: data.expenses, summary: summary(), summaryCustomAttr: { style: { justifyContent: 'space-between' } } }), _jsx(Spacer, { size: 20 })] }));
}
export default ERPGatewayExportErrorsGrid;
